module.exports = __webpack_public_path__ + "static/media/icon-card-trend-monitoring.c824b592.svg";